/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Contract = {
  properties: {
    id: {
      type: 'string',
    },
    file: {
      type: 'File',
    },
    hirers: {
      type: 'array',
      contains: {
        type: 'HirerBasicInfo',
      },
      isRequired: true,
    },
    template: {
      type: 'ContractTemplateBasicInfo',
      isRequired: true,
    },
    parameters: {
      properties: {
      },
      isRequired: true,
    },
    status: {
      type: 'ContractStatus',
      isRequired: true,
    },
    expiration: {
      type: 'string',
      isRequired: true,
      format: 'date',
    },
    hiredCNPJ: {
      type: 'string',
      isRequired: true,
    },
    signers: {
      type: 'array',
      contains: {
        type: 'Signer',
      },
      isRequired: true,
    },
    elaboratorId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
